/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Blueprint,
  Blueprints,
  BlueprintsParams,
  FleetBlueprints,
  FleetBlueprintsParams,
  FleetWantedBlueprints,
  FleetWantedBlueprintsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Blueprints list
 */
export const blueprints = (
    params?: MaybeRefOrGetter<BlueprintsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Blueprints>(
      {url: `/blueprints`, method: 'GET',
        params, signal
    },
      );
    }




export const getBlueprintsQueryKey = (params?: MaybeRefOrGetter<BlueprintsParams>,) => {
    return [
    'blueprints', ...(params ? [params] : [])
    ] as const;
    }


export const getBlueprintsQueryOptions = <TData = Awaited<ReturnType<typeof blueprints>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<BlueprintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getBlueprintsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof blueprints>>> = ({ signal }) => blueprints(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof blueprints>>, TError, TData>
}

export type BlueprintsQueryResult = NonNullable<Awaited<ReturnType<typeof blueprints>>>
export type BlueprintsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Blueprints list
 */

export function useBlueprints<TData = Awaited<ReturnType<typeof blueprints>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<BlueprintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBlueprintsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Blueprint detail
 */
export const blueprint = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Blueprint>(
      {url: `/blueprints/${slug}`, method: 'GET', signal
    },
      );
    }




export const getBlueprintQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'blueprints',slug
    ] as const;
    }


export const getBlueprintQueryOptions = <TData = Awaited<ReturnType<typeof blueprint>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprint>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getBlueprintQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof blueprint>>> = ({ signal }) => blueprint(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof blueprint>>, TError, TData>
}

export type BlueprintQueryResult = NonNullable<Awaited<ReturnType<typeof blueprint>>>
export type BlueprintQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Blueprint detail
 */

export function useBlueprint<TData = Awaited<ReturnType<typeof blueprint>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprint>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBlueprintQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Mark a blueprint as owned
 */
export const ownBlueprint = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<void>(
      {url: `/blueprints/${slug}/own`, method: 'PUT', signal
    },
      );
    }




export const getOwnBlueprintMutationKey = () => ['ownBlueprint'] as const;

export const getOwnBlueprintMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownBlueprint>>, TError,OwnBlueprintMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof ownBlueprint>>, TError,OwnBlueprintMutationVariables, TContext> => {

const mutationKey = getOwnBlueprintMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ownBlueprint>>, OwnBlueprintMutationVariables> = (props) => {
          const {slug} = props ?? {};

          return  ownBlueprint(slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OwnBlueprintMutationResult = NonNullable<Awaited<ReturnType<typeof ownBlueprint>>>

    export type OwnBlueprintMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type OwnBlueprintMutationVariables = {slug: string}

    /**
 * @summary Mark a blueprint as owned
 */
export const useOwnBlueprint = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownBlueprint>>, TError,OwnBlueprintMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof ownBlueprint>>,
        TError,
        OwnBlueprintMutationVariables,
        TContext
      > => {
      return useMutation(getOwnBlueprintMutationOptions(options), queryClient);
    }
    /**
 * @summary Drop a blueprint's owned mark
 */
export const unownBlueprint = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<void>(
      {url: `/blueprints/${slug}/own`, method: 'DELETE', signal
    },
      );
    }




export const getUnownBlueprintMutationKey = () => ['unownBlueprint'] as const;

export const getUnownBlueprintMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unownBlueprint>>, TError,UnownBlueprintMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unownBlueprint>>, TError,UnownBlueprintMutationVariables, TContext> => {

const mutationKey = getUnownBlueprintMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unownBlueprint>>, UnownBlueprintMutationVariables> = (props) => {
          const {slug} = props ?? {};

          return  unownBlueprint(slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnownBlueprintMutationResult = NonNullable<Awaited<ReturnType<typeof unownBlueprint>>>

    export type UnownBlueprintMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnownBlueprintMutationVariables = {slug: string}

    /**
 * @summary Drop a blueprint's owned mark
 */
export const useUnownBlueprint = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unownBlueprint>>, TError,UnownBlueprintMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unownBlueprint>>,
        TError,
        UnownBlueprintMutationVariables,
        TContext
      > => {
      return useMutation(getUnownBlueprintMutationOptions(options), queryClient);
    }
    /**
 * @summary Put a blueprint on the wishlist
 */
export const wantBlueprint = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<void>(
      {url: `/blueprints/${slug}/want`, method: 'PUT', signal
    },
      );
    }




export const getWantBlueprintMutationKey = () => ['wantBlueprint'] as const;

export const getWantBlueprintMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wantBlueprint>>, TError,WantBlueprintMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof wantBlueprint>>, TError,WantBlueprintMutationVariables, TContext> => {

const mutationKey = getWantBlueprintMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof wantBlueprint>>, WantBlueprintMutationVariables> = (props) => {
          const {slug} = props ?? {};

          return  wantBlueprint(slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WantBlueprintMutationResult = NonNullable<Awaited<ReturnType<typeof wantBlueprint>>>

    export type WantBlueprintMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type WantBlueprintMutationVariables = {slug: string}

    /**
 * @summary Put a blueprint on the wishlist
 */
export const useWantBlueprint = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wantBlueprint>>, TError,WantBlueprintMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof wantBlueprint>>,
        TError,
        WantBlueprintMutationVariables,
        TContext
      > => {
      return useMutation(getWantBlueprintMutationOptions(options), queryClient);
    }
    /**
 * @summary Take a blueprint off the wishlist
 */
export const unwantBlueprint = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<void>(
      {url: `/blueprints/${slug}/want`, method: 'DELETE', signal
    },
      );
    }




export const getUnwantBlueprintMutationKey = () => ['unwantBlueprint'] as const;

export const getUnwantBlueprintMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unwantBlueprint>>, TError,UnwantBlueprintMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unwantBlueprint>>, TError,UnwantBlueprintMutationVariables, TContext> => {

const mutationKey = getUnwantBlueprintMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unwantBlueprint>>, UnwantBlueprintMutationVariables> = (props) => {
          const {slug} = props ?? {};

          return  unwantBlueprint(slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnwantBlueprintMutationResult = NonNullable<Awaited<ReturnType<typeof unwantBlueprint>>>

    export type UnwantBlueprintMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnwantBlueprintMutationVariables = {slug: string}

    /**
 * @summary Take a blueprint off the wishlist
 */
export const useUnwantBlueprint = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unwantBlueprint>>, TError,UnwantBlueprintMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unwantBlueprint>>,
        TError,
        UnwantBlueprintMutationVariables,
        TContext
      > => {
      return useMutation(getUnwantBlueprintMutationOptions(options), queryClient);
    }
    /**
 * @summary Blueprints the fleet's members hold
 */
export const fleetBlueprints = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetBlueprintsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetBlueprints>(
      {url: `/fleets/${fleetSlug}/blueprints`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetBlueprintsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetBlueprintsParams>,) => {
    return [
    'fleets',fleetSlug,'blueprints', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetBlueprintsQueryOptions = <TData = Awaited<ReturnType<typeof fleetBlueprints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetBlueprintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetBlueprints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetBlueprintsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetBlueprints>>> = ({ signal }) => fleetBlueprints(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetBlueprints>>, TError, TData>
}

export type FleetBlueprintsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetBlueprints>>>
export type FleetBlueprintsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Blueprints the fleet's members hold
 */

export function useFleetBlueprints<TData = Awaited<ReturnType<typeof fleetBlueprints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetBlueprintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetBlueprints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetBlueprintsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Blueprints the fleet's members want
 */
export const fleetWantedBlueprints = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetWantedBlueprintsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetWantedBlueprints>(
      {url: `/fleets/${fleetSlug}/blueprints/wanted`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetWantedBlueprintsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetWantedBlueprintsParams>,) => {
    return [
    'fleets',fleetSlug,'blueprints','wanted', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetWantedBlueprintsQueryOptions = <TData = Awaited<ReturnType<typeof fleetWantedBlueprints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetWantedBlueprintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetWantedBlueprints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetWantedBlueprintsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetWantedBlueprints>>> = ({ signal }) => fleetWantedBlueprints(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetWantedBlueprints>>, TError, TData>
}

export type FleetWantedBlueprintsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetWantedBlueprints>>>
export type FleetWantedBlueprintsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Blueprints the fleet's members want
 */

export function useFleetWantedBlueprints<TData = Awaited<ReturnType<typeof fleetWantedBlueprints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetWantedBlueprintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetWantedBlueprints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetWantedBlueprintsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






